<template>
  <main class="wait-page flex flex-col justify-center items-center min-h-[60vh] py-16 sm:py-24 px-4 sm:px-6">
    <section class="text-center max-w-[594px] mx-auto rounded-lg">
      <h1 class="font-barlow-condensed font-bold text-white uppercase text-3xl sm:text-4xl lg:text-5xl leading-tight mb-8 sm:mb-10">
        Le jeu Petit Navire<br />
        n'a pas encore commencé...
      </h1>
      <div class="wait-bleu-block">
        <p class="wait-bleu-text">
          Rendez-vous sur ce site à partir du 1er mai 2026 pour tenter votre chance !
        </p>
      </div>
    </section>
  </main>
</template>

<script>
export default {
  name: "WaitView",
};
</script>

<style scoped>
.wait-page {
  background-color: #0d2651;
  background-image: url("@/assets/images/fond-perdu.svg");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.wait-bleu-block {
  display: inline-flex;
  max-width: 420px;
  min-height: 76px;
  transform: rotate(-2deg);
  padding: 10px 14px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  background-color: #2490be;
  border-radius: 8px;
}

.wait-bleu-text {
  color: #fff;
  text-align: center;
  font-family: "Barlow Condensed", sans-serif;
  font-size: 21px;
  font-style: normal;
  font-weight: 700;
  line-height: 26px;
  margin: 0;
}
</style>
